import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-tab',
    templateUrl: './tab.component.html',
    styleUrls: ['./tab.component.css'],
    standalone: true
})
export class TabComponent {
  @Input('tabTitle') title: string;
  @Input() active = false;
}
